/**
 * IXD Preview 비교(렌더 뷰) 스토어 Provider — 페이지 스코프.
 */

import { useRef } from "react";
import {
  createIxdPreviewCompareStore,
  IxdPreviewCompareStoreContext,
} from "@/stores/ixd-preview-compare";

export const IxdPreviewCompareStoreProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const storeRef = useRef<ReturnType<
    typeof createIxdPreviewCompareStore
  > | null>(null);
  if (!storeRef.current) {
    storeRef.current = createIxdPreviewCompareStore();
  }

  return (
    <IxdPreviewCompareStoreContext.Provider value={storeRef.current}>
      {children}
    </IxdPreviewCompareStoreContext.Provider>
  );
};
